import React, { useEffect, useState }  from 'react';

import { Typography, Collapse, LinearProgress, } from '@mui/material';

// import Spinner from '../Spinner';

// import useStyles from './useStyles';

function SaveStatus(props) {
  const {
    title,
    titleVariant='subtitle2',
    forcedDisplay=false,//Принудительный показ сообщения без относительно загрузки
    errShowTime=false,//время, через которое будет спрятано сообщение об ошибке (по умолчанию не будет спрятано)
    successShowTime=false,//время, через которое будет спрятано сообщение об успехе (по умолчанию не будет спрятано)
    successMsg, //текст сообщения об успехе по умолчанию
    successMsgPriority='data', //приоритет показа сообщения.
                                //варианты(в их рамка перечислено, что будет показано при успехе, по принципу "есл есть"):
                                //'data':1-сообщение из dataObj.data.message, 2 - successMsg, 3 - "Успешно"
                                //'msg':1 - successMsg, 2 - "Успешно"
                                //'default'(или что угодно):"Успешно"
    postErrorAction,//ф-ция которая будет вызвана после ошибки по истечению времени ее показа (или немедленно)
    postSuccessAction,//ф-ция которая будет вызвана после успеха по истечению времени его показа (или немедленно)
    dataObj:{//это типовой объект загрузки данных из апи
      error, //при ошибках они попадают сюда
      loading, //при загрузки здесь отображен ее процесс
      to, //для паджинации - количество загруженных итемов
      total, //для паджинации - количество итемов всего
      data:{message}={}, //по завершению загрузки, сюда могут попасть информационные сообщения
    }={},
    dataObj,
    ...rest //прочие параметры, будут переданы в отображалку как есть
  } = props;

  // const classes = useStyles();

  if(error) console.log('Пользователю мы показали краткий вывод данных вот об этой ошибке:', error)

  const [show,setShow]=useState(false);
  const [isLoading, setIsLoading]=useState(false);

  const SMD='Успешно'; //Текст сообщения об успехе по умолчанию
  let timer; //хранилище таймеров показа
  let preparedSuccessMessage; //собранное сообщение об успехе

  if(successMsgPriority==='data'){
    preparedSuccessMessage=(message)?message:(successMsg?successMsg:SMD);
  }else if(successMsgPriority==='msg'){
    preparedSuccessMessage=successMsg?successMsg:SMD;
  }else{
    preparedSuccessMessage=SMD;
  }

  useEffect(()=>{
    if(isLoading && !loading){
      //Только что закончилась загрузка
      setIsLoading(false);
      if(error){
        //лоадинг завершился с ошибкой, включаем режим показа ошибки
        _setShow('error', errShowTime, postErrorAction);
      }else{
        //лоадинг завершился, ошибок нету,  включаем режим показа успеха
        _setShow('success', successShowTime, postSuccessAction);
      }
    }else if(!isLoading && loading){
      setIsLoading(true);
      setShow('loading');
    }
  },[loading]);

  useEffect(()=>{
    if(forcedDisplay){
      //если включен принудительный показ сообщения об ошибке/успехе (т.е. без проверки выполнения загрузки)
      if(error){
        //принудительно переходим в режим показа ошибки
        _setShow('error', errShowTime, postErrorAction);
      }else{
        //принудительно переходим в режим показа успеха
        _setShow('success', successShowTime, postSuccessAction);
      }
    }
    return ()=>{
      //на случай если интервал тикает, сначала его очистим
      if(timer){
        clearTimeout(timer);
        timer=false;
      }
      //потом выключим показ чего бы там ни было
      setShow(false);
    }
  },[]);

  const _setShow=(showMode,timeoutValue,postAction)=>{
    //ф-ция включения показа, чего скажут
    if(!timeoutValue){
      //если нету интервала - все действия выполнить немедленно
      setShow(showMode);
      if(postAction) postAction();
    }else{
      //если есть timer - показ включаем сразу, и ставим интервал, который скроет показ и выполнит действия после показа
      setShow(showMode);
      //на случай если интервал тикает, сначала его очистим
      if(timer){
        clearTimeout(timer);
        timer=false;
      }
      //а теперь запустим новый
      timer=setTimeout(()=>{
        setShow(false);
        //если задана ф-ция действий  она будет вызвана, когда закончится показ
        if(postAction) postAction();
      },timeoutValue);
    }
  }
  return(
    <Collapse in={!!show}>
      <span>
        {(title)?(<Typography gutterBottom variant={titleVariant}>{title}</Typography>):''}
        {(show==='error' && error && error.message)?(<Typography gutterBottom color="error" {...rest}>{error.message}</Typography>):''}
        {(show==='loading' && loading!=='partload')?(<LinearProgress />):''}
        {(show==='loading' && loading==='partload' && to && total)?(<LinearProgress variant="determinate" value={Math.round(to/total*100)} />):''}
        {(show==='success')?(<Typography gutterBottom {...rest}>{preparedSuccessMessage}</Typography>):''}
      </span>
    </Collapse>
  );
}

export default SaveStatus;
